export const TASK_PLANNER_SIDEBAR_ITEM = {
  userId: "taskPlanner",
  subMenu: null,
  name: "Task Planner",
  svg: `<svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="12" cy="12" r="9" stroke="#707070" stroke-width="1.6"/>
<path d="M12 7V12L15 14" stroke="#707070" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`,
  svgfill: `<svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="12" cy="12" r="9" stroke="#2576BC" stroke-width="1.6"/>
<path d="M12 7V12L15 14" stroke="#2576BC" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`,
};
